import apiService from './apiService';

const uploadService = {
  /**
   * Kép feltöltése a backendre (ami majd R2-re tölti).
   * @param {File} file - A feltöltendő File objektum.
   * @param {string} uploadType - A feltöltés típusa (pl. 'avatar', 'providerGallery', 'providerProfile').
   * @param {number} entityId - A feltöltéshez tartozó entitás ID-ja (pl. userId, providerId).
   * @returns {Promise<object>} A backend válasza, tartalmazza az URL-t.
   */
  async uploadImage(file, uploadType, entityId) {
    try {
      const formData = new FormData();
      formData.append('image', file);

      // MÓDOSÍTVA: uploadType és entityId query paraméterként
      // Fontos: encodeURIComponent-tel kódoljuk az értékeket, ha speciális karaktereket tartalmazhatnak
      const response = await apiService.post(`/upload/image?uploadType=${encodeURIComponent(uploadType)}&entityId=${encodeURIComponent(entityId)}`, formData);
      return response;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  },
};

export default uploadService;